import { MailerInfo } from "./MailerInfo";
import { EMailData } from "../../../library/ts/node/server/mailer/EMailData";
import { Request } from "../../../library/ts/html/server/Request";

export class RJMailer
{
  path = "";
  key = "";
  
  load( info:MailerInfo )
  {
    this.path = `${info.path}`;
    this.key = `${info.key}`;
  }

  async send( mailData:EMailData ):Promise<void>
  {
    ( mailData as any ).key = this.key;
    
    let url = this.path;

    console.log( "sending:", mailData.to, mailData.subject );

    let response = await Request.post<any,any>( url, mailData, true );

    console.log( "response:", response );
    return Promise.resolve();
  }
}